/**
 * Indicates the stucture of Diagram Password Protection static object
 */
export class DiagramPasswordModel {
    public updatedBy: string;
    public isEnabled: boolean;
}
